import { defineStore } from "pinia";
import { collection, getFirestore } from "firebase/firestore";
import type { INews } from "~~/types/information";
import type { updateNewsParams } from "~~/server/api/news/update.put";
import type { CreateNewParams } from "~~/server/api/news/create.post";
import type { deleteNewsParams } from "~~/server/api/news/delete.delete";

export const useNewsStore = defineStore("news", () => {
  const db = getFirestore();
  const { updateNews: updateNewsAPI, createNews: createNewsAPI, deleteNews: deleteNewsAPI } = useNetwork();
  const newsCollectionRef = collection(db, "news");
  const { data: newsList, pending: isLoading, error } = useCollection<INews>(newsCollectionRef);

  const bannerNews = computed(() => {
    return newsList.value.filter((news) => news.showOnBanner);
  });

  const updateNews = async (updatedNews: updateNewsParams) => {
    await updateNewsAPI({
      body: updatedNews,
    });
  };

  async function createNews(newNews: CreateNewParams) {
    await createNewsAPI({
      body: newNews,
    });
  }

  async function deleteNews(newsToDelete: deleteNewsParams) {
    await deleteNewsAPI({
      id: newsToDelete.id,
    });
  }

  return {
    newsList,
    isLoading,
    error,
    bannerNews,
    updateNews,
    createNews,
    deleteNews,
  };
});
